(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "debounce", "../hooks/useActive"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("debounce"), require("../hooks/useActive"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.debounce, global.useActive);
    global.useViewScrollRestoration = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _debounce, _useActive) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useViewScrollRestoration = useViewScrollRestoration;
  _debounce = _interopRequireDefault(_debounce);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function useViewScrollRestoration(ref) {
    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        locationHistory = _useContext.locationHistory;

    var routeMatch = (0, _reactRouter.useRouteMatch)();
    var active = (0, _useActive.useActive)();
    var history = (0, _reactRouter.useHistory)(); // This effect must only be executed at the point of mounting.

    (0, _react.useLayoutEffect)(function () {
      var element = ref.current;

      var restoreScroll = function restoreScroll() {
        var element = ref.current;
        var state = locationHistory.get(routeMatch.key);
        if (state) element.scrollTop = state.scrollTop;
      };

      var saveScroll = (0, _debounce.default)(function (event) {
        locationHistory.set(routeMatch.key, {
          scrollTop: event.target.scrollTop,
          scrollHeight: event.target.scrollHeight
        });
      }, 100);

      if (!active && history.location.key !== routeMatch.key) {
        // for premount
        restoreScroll();
      } else if (active && history.action === 'POP') {
        // for refresh
        restoreScroll();
      } // for save scroll position.


      element === null || element === void 0 ? void 0 : element.addEventListener('scroll', saveScroll);
      return function () {
        element === null || element === void 0 ? void 0 : element.removeEventListener('scroll', saveScroll);
      }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  }
});